export default __webpack_public_path__ + "static/media/LDO.b99e6f2b.svg";